import { createFileRoute } from "@tanstack/react-router";
import { JoinPage } from "@/pages/auth/JoinPage";

export const Route = createFileRoute("/_onboarding/join/")({ component: JoinPage });
